import { QueryParams } from "@/models/query-params.model";
import api from "@/services/api-config/rxjs-config";
import { Observable } from "rxjs";

export class CategoriesRest {
  getCategories(params: QueryParams): Observable<any> {
    const url: string = `/categories`;
    return api.get(url, params);
  }
}
